import SignUpLayout from './SignUpLayout';
import ForgotPasswordLayout from './ForgotPasswordLayout';
import LoginLayout from './LoginLayout';
import BroadcastMessage from './broadcastMessage';

import { makeStyles } from '@material-ui/core/styles';

import { Paper } from '@material-ui/core';

import { useState, useEffect } from 'react';
import ResendActivationLayout from './ResendActivationLayout';
import FirstLogResetPassword from 'components/Login/firstLogResetPassword';
import FooterMessage from 'components/Login/footerMessage';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(2),
        width: 500,
    },
    loginLogo: {
        objectFit: 'contain',
        height: 150,
    },
}));

const SLayout = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`;

const Login = () => {
    const classes = useStyles();

    const shouldUpdatePassword = useSelector((state) => state.user.shouldUpdatePassword);

    const showLoginLayout = 'showLoginLayout';
    const showForgotPasswordLayout = 'showForgotPasswordLayout';
    const showSignUpLayout = 'showSignUpLayout';
    const showResendActivationLayout = 'ResendActivationLayout';
    const showFirstLogResetPassword = 'showFirstLogResetPassword';
    const [pageComponent, setPageComponent] = useState(showLoginLayout);
    const [page, setPage] = useState(null);

    const checkShowPageComponent = () => {
        if (pageComponent === showLoginLayout) {
            return (
                <LoginLayout
                    setPageComponent={setPageComponent}
                    showSignUpLayout={showSignUpLayout}
                    showForgotPasswordLayout={showForgotPasswordLayout}
                    showResendActivationLayout={showResendActivationLayout}
                />
            );
        } else if (pageComponent === showForgotPasswordLayout) {
            return <ForgotPasswordLayout setPageComponent={setPageComponent} showLoginLayout={showLoginLayout} />;
        } else if (pageComponent === showSignUpLayout) {
            return <SignUpLayout setPageComponent={setPageComponent} showLoginLayout={showLoginLayout} />;
        } else if (pageComponent === showResendActivationLayout) {
            return <ResendActivationLayout setPageComponent={setPageComponent} showLoginLayout={showLoginLayout} />;
        } else if (pageComponent === showFirstLogResetPassword) {
            return <FirstLogResetPassword setPageComponent={setPageComponent} showLoginLayout={showLoginLayout} />;
        } else {
            return null;
        }
    };

    useEffect(() => {
        setPage(checkShowPageComponent());
        // eslint-disable-next-line
    }, [pageComponent]);

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        if (params.get('passwordDisabled') === 'true') {
            setPageComponent(showForgotPasswordLayout);
        }
    }, []);

    useEffect(() => {
        if (shouldUpdatePassword) {
            setPageComponent(showFirstLogResetPassword);
        }
    }, [shouldUpdatePassword]);

    return (
        <>
            <SLayout>
                <BroadcastMessage />
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <Paper className={classes.paper}>{page}</Paper>
                </div>
                <FooterMessage />
            </SLayout>
        </>
    );
};

export default Login;